var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.9375H4.5C3.15 21.9375 2.0625 20.85 2.0625 19.5V14.25C2.0625 13.9312 2.30625 13.6875 2.625 13.6875C2.94375 13.6875 3.1875 13.9312 3.1875 14.25V19.5C3.1875 20.2312 3.76875 20.8125 4.5 20.8125H19.5C20.2313 20.8125 20.8125 20.2312 20.8125 19.5V14.25C20.8125 13.9312 21.0562 13.6875 21.375 13.6875C21.6938 13.6875 21.9375 13.9312 21.9375 14.25V19.5C21.9375 20.85 20.85 21.9375 19.5 21.9375Z",
    fill: "#495464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6063C8.6625 14.6063 5.325 13.7063 2.34375 11.925C2.175 11.8125 2.0625 11.6438 2.0625 11.4375V8.25C2.0625 6.9 3.15 5.8125 4.5 5.8125H19.5C20.85 5.8125 21.9375 6.9 21.9375 8.25V11.4375C21.9375 11.6438 21.825 11.8125 21.6562 11.925C18.675 13.7063 15.3375 14.6063 12 14.6063ZM3.1875 11.1188C8.64375 14.2688 15.3562 14.2688 20.8125 11.1188V8.25C20.8125 7.51875 20.2313 6.9375 19.5 6.9375H4.5C3.76875 6.9375 3.1875 7.51875 3.1875 8.25V11.1188Z",
    fill: "#495464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 5.0625C15.0563 5.0625 14.8125 4.81875 14.8125 4.5C14.8125 3.76875 14.2312 3.1875 13.5 3.1875H10.5C9.76875 3.1875 9.1875 3.76875 9.1875 4.5C9.1875 4.81875 8.94375 5.0625 8.625 5.0625C8.30625 5.0625 8.0625 4.81875 8.0625 4.5C8.0625 3.15 9.15 2.0625 10.5 2.0625H13.5C14.85 2.0625 15.9375 3.15 15.9375 4.5C15.9375 4.81875 15.6937 5.0625 15.375 5.0625Z",
    fill: "#495464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.05af9c1342e1591f1edae49efbb12926.svg";
export { ForwardRef as ReactComponent };